var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy91bnBhcmFtLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvdW5wYXJhbS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixPQUFBLEdBQVUsU0FBQyxHQUFEO0FBQ3pCLE1BQUE7O0lBRDBCLE1BQU0sUUFBUSxDQUFDOztFQUN6QyxJQUFPLE9BQU8sR0FBUCxLQUFjLFFBQXJCO0FBQ0UsVUFBVSxJQUFBLFNBQUEsQ0FBVSxrQ0FBQSxHQUFrQyxDQUFDLElBQUksQ0FBQyxTQUFMLENBQWUsR0FBZixDQUFELENBQTVDLEVBRFo7O0VBRUEsSUFBQSxHQUFPO0VBRVAsUUFBQSxHQUFXLEdBQUcsQ0FBQyxPQUFKLENBQVksS0FBWixFQUFtQixLQUFuQixDQUF5QixDQUFDLEtBQTFCLENBQWdDLEdBQWhDO0FBQ1gsT0FBQSwwQ0FBQTs7SUFDRSxJQUFBLENBQWdCLENBQUEsS0FBQSxHQUFRLGtCQUFrQixDQUFDLElBQW5CLENBQXdCLE1BQXhCLENBQVIsQ0FBaEI7QUFBQSxlQUFBOztBQUNBO01BQUksSUFBSyxDQUFBLGtCQUFBLENBQW1CLEtBQU0sQ0FBQSxDQUFBLENBQXpCLENBQUEsQ0FBTCxHQUFvQyxrQkFBQSxDQUFtQixLQUFNLENBQUEsQ0FBQSxDQUF6QixFQUF4QztLQUFBO0FBRkY7U0FHQTtBQVR5QiJ9
